<div class="p-20-px">
  <div *ngIf="entityData?.secondaryDetails?.ontologyUrl; else noContent">
    <ng-container *ngIf="entityData?.category === 'Product Box'; else otherCategory">
      <img *ngIf="devicesOnline" [src]="entityData?.secondaryDetails?.ontologyUrl + token" [alt]="entityData?.name" class="img-fluid"/>
      <img *ngIf="!devicesOnline" [src]="entityData?.secondaryDetails?.ontologyUrlFaulty + token" [alt]="entityData?.name" class="img-fluid"/>
    </ng-container>
    <ng-template #otherCategory>
      <img [src]="entityData?.secondaryDetails?.ontologyUrl + token" [alt]="entityData?.name" class="img-fluid"/>
    </ng-template>
  </div>
  <ng-template #noContent>
    <div class="text-center">
      <img src="../../../../../../assets/images/no-data-idec.svg" matToolTip="No Data" class="h-150" alt="no data">
    </div>
  </ng-template>
</div>